<template>
  <div class="fullscreen-background">

    <Keypress :multiple-keys="multiple" key-event="keyup" @success="checkPoint" @wrong="otherMethod" />





    <div class="mb-0 text-center">
      <img class="logo-size" src="images/logo_muic.png" alt="imag_smartauthenapp_1" />
    </div>

    <!-- true: ui check query -->
    <div v-if="getUrlPath !== `Not spectify {{token_event}}`">
      <!-- true : loading rander ui -->
      <div v-if="!loadingMainUi">

        <div v-if="Object.keys(dataEvent).length != 0">


          <a-row :gutter="[24, 24]" justify="space-around" align="middle" class="mt-0">

            <a-col :span="20" :offset="2" class="col-form">
              <a-row>
                <a-col :span="12">
                  <div class="time-display-wrapper text-left">
                    <div class="date-badge font-web shadow-sm">
                      <a-icon type="calendar" class="mr-5" />
                      {{ moment(serverNowDate || new Date()).format('dddd, DD MMMM YYYY') }}
                    </div>
                    <h1 class="digital-clock font-web mt-5 mb-0">
                      <a-icon class="mr-10 clock-icon" type="clock-circle" theme="filled" />
                      <span style="color: #508D69;">{{ currentTime }}</span>
                    </h1>
                  </div>
                </a-col>
                <a-col class="text-right" :span="12">
                  <div class="stat-badge">
                    <p class="stat-label font-web">Total Check-ins</p>
                    <h3 class="stat-value font-web">{{ countData }} <span class="stat-unit">people</span></h3>
                  </div>
                </a-col>
              </a-row>

              <div class="main-card-glass">
                <a-row :gutter="[24, 24]" align="middle">
                  <a-col :xs="24" :sm="8" :md="6" :lg="6">
                    <div class="text-center photo-container">
                      <img v-if="checkDataRender(dataProfile, 'Photo') === '-'" alt="imag_smartauthenapp_2"
                        class="img-size-lock shadow-xl" src="images/avatar.png" />
                      <img v-else alt="imag_smartauthenapp_3" class="img-size-lock shadow-xl" :src="`${checkDataRender(
                        dataProfile,
                        'Photo'
                      )}`" />
                    </div>
                  </a-col>
                  <a-col :xs="24" :sm="16" :md="18" :lg="18">
                    <a-row type="flex" :gutter="[24, 24]">
                      <a-col flex="1 1 300px" class="info-section">
                        <h4 class="event-title font-web">
                          Scan your card to event :
                          <a-switch size="small" default-checked @change="onChange">
                            <a-icon slot="checkedChildren" type="qrcode" />
                            <a-icon slot="unCheckedChildren" type="qrcode" />
                          </a-switch>
                          &nbsp;
                          <a-switch size="small" @change="onChangeEdit">
                            <a-icon slot="checkedChildren" type="edit" />
                            <a-icon slot="unCheckedChildren" type="edit" />
                          </a-switch>
                        </h4>
                        <p class="event-subtitle font-web">Event Code :: <span>{{ getUrlPath }} / {{ formattedEpoch
                            }}</span></p>
                        <div class="event-badge">
                          <h4 class="font-web" v-html="dataEvent.name"></h4>
                        </div>

                        <div v-if="loadingCheck" class="card-loading shadow-md">
                          <a-spin size="large" />
                          <p class="font-web mt-10" style="font-size: 18px;">Loading...</p>
                        </div>
                        <div v-else class="status-container mt-20">
                          <div v-if="![''].includes(`${textsugess}`)">
                            <div class="alert-box shadow-md">
                              <h5 class="font-web text-danger mt-0 mb-0">{{ textsugess }}</h5>
                            </div>
                          </div>
                          <div v-else>
                            <div :class="['result-box shadow-md', hasSuccess ? 'success-bg' : 'default-bg']">
                              <a-row :gutter="[16, 16]" type="flex" align="middle">
                                <a-col :span="8" class="text-right">
                                  <h4 class="labelx-font font-web text-muted">Name :</h4>
                                </a-col>
                                <a-col :span="16" class="text-left">
                                  <h4 v-if="!['', null, 'null'].includes(`${valKey}`)" class="value-font font-web">{{
                                    valKey }}</h4>
                                  <h4 v-else class="value-font font-web">{{ checkDataRender(dataProfile, "full_name") }}
                                  </h4>
                                </a-col>
                              </a-row>
                              <a-divider style="margin: 12px 0;" />
                              <a-row :gutter="[16, 16]" type="flex" align="middle">
                                <a-col :span="8" class="text-right">
                                  <h4 class="labelx-font font-web text-muted">Time Stamp :</h4>
                                </a-col>
                                <a-col :span="16" class="text-left">
                                  <h4 class="value-font font-web">
                                    <span
                                      v-if="!['', '-', null, 'null'].includes(`${checkDataRender(dataProfile, 'checked_in_at')}`)">
                                      {{ moment(checkDataRender(dataProfile, "checked_in_at")).format('DD MMMM YYYY, HH: mm: ss') }}</span>
                                  </h4>
                                </a-col>
                              </a-row>
                            </div>
                          </div>
                        </div>
                      </a-col>
                      <a-col v-if="showQr" flex="0 1 320px" class="qr-section">
                        <div v-if="isEnrollmentEvent" class="enrollment-card shadow-lg">
                          <div class="text-center">
                            <div v-if="loadingEnrollmentCheck">
                              <a-spin size="large" />
                              <p class="mt-10 font-web"><strong>Checking Enrollment...</strong></p>
                            </div>
                            <div v-else>
                              <a-result class="font-web enrollment-result" v-if="enrollmentStatus === 'success'"
                                status="success" title="Enrollment Completed" />
                              <a-result class="font-web enrollment-result" v-else-if="enrollmentStatus === 'warning'"
                                status="warning" title="Enrollment Not Completed"
                                sub-title="Please complete your enrollment form." />
                              <a-result class="font-web enrollment-result" v-else status="info"
                                title="Enrollment Form Status"
                                sub-title="Please scan your card to check your status." />
                            </div>
                          </div>
                        </div>
                        <div v-else class="qr-card shadow-lg">
                          <qr-code class="qr-canvas" :text="urlQr" :size="200"></qr-code>
                          <div class="text-center mt-20">
                            <p class="font-web font-weight-bold mt-0 mb-0" style="font-size: 16px;">
                              <a-icon type="mobile" /> Check-in By QR
                            </p>
                          </div>
                        </div>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </div>


              <!-- logs -->
              <div v-if="!isEnrollmentEvent">
                <h5 class="mt-0 mb-5">Attendance history</h5>
                <small>Check in and out of the latest locations at various points
                  [TokenID : {{ valKey }}]</small>
                <a-table class="mt-5" :columns="columns" size="small" :pagination="false" bordered
                  :data-source="dataAttanUser" :scroll="{ y: 150 }">

                  <template slot="type_user" slot-scope="text, record">
                    <a-tag :color="'#320A6B'"><span style="font-size: 14px;font-weight: 500;"
                        class="mt-0 mb-0 font-web">{{ record.check_in_type }}</span></a-tag>

                  </template>
                  <template slot="created_at" slot-scope="text, record">

                    <p style="font-size: 16px;font-weight: 500;" class="mt-0 mb-0 font-web">{{
                      moment(record.checked_in_at).format('LTS') }}</p>
                  </template>
                  <template slot="full_name" slot-scope="text, record">
                    <p style="font-size: 14px;font-weight: 500;" class="mt-0 mb-0 font-web">{{ record.full_name }}</p>
                  </template>
                  <template slot="user_id" slot-scope="text, record">
                    <p style="font-size: 16px;font-weight: 500;" class="mt-0 mb-0 font-web">{{ record.user_id }}</p>
                  </template>
                </a-table>
              </div>
            </a-col>
          </a-row>

        </div>
        <div v-else class="text-center">
          <a-result status="error" title="Failed" sub-title="Please check connection api / event url / Internet.">
            <template #extra>
              <p class="text-muted">CODE EVENT : {{ getUrlPath }}</p>
            </template>

            <div class="desc">
              <p class="font-web" style="font-size: 16px;">
                <strong>หากพบปัญหาเรื่องการติดตั้ง / หรือเปิดตัวระบบ โปรดเเจ้งทีม IN_HOUSE </strong>
              </p>
            </div>
          </a-result>
        </div>

      </div>
      <!-- process : loading rander ui -->
      <div v-else>

        <a-skeleton />
        <div class="mt-20 text-center">

        </div>

      </div>

    </div>
    <!-- false: ui check query -->
    <div v-else>
      <div class="mt-20 text-center">
        <h5 class="mt-10 mb-10 font-web text-danger">โปรดตรวจสอบ url ของท่าน {{ token_event }}</h5>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment';

const columns = [
  {
    title: "ID",
    dataIndex: "user_id",
    className: "column-font ml-50 text-center",
    scopedSlots: { customRender: "user_id" },
    width: 150,
  },
  {
    title: "Type",
    dataIndex: "type_user",
    className: "column-font ml-50",
    scopedSlots: { customRender: "type_user" },
    width: 150,
  },
  {
    sort: true,
    title: "Name",
    dataIndex: "full_name",
    className: "column-font ml-50",
    scopedSlots: { customRender: "full_name" },
    width: 300,
  },
  {
    title: "Checked in at",
    dataIndex: "created_at",
    className: "column-font",
    scopedSlots: { customRender: "created_at" },
  },
];
export default {
  components: {
    Keypress: () => import("vue-keypress"),
  },
  data() {
    return {
      loadingMainUi: false,
      loadingCheck: false,
      countData: 0,
      dataEvent: {},
      dataAttanUser: [],
      hasSuccess: false,
      columns,
      valTemp: "x",
      // 022977837617809160
      // 111111111111111111
      // 111111111111111112
      valKey: "",
      multiple: [
        {
          keyCode: 13, // Enter
          modifiers: [],
          preventDefault: true,
        },
      ],
      // res api data
      modalCaseRequest: false,
      modalCaseBlock: false,
      timeStart: this.moment().format("YYYY-MM-DD"),
      timeEnd: this.moment().add(1, "days").format("YYYY-MM-DD"),
      dataLocation: [],
      dataProfile: {},
      // time zone
      serverNowDate: "",
      currentTime: null,

      hou: 0,
      sec: 5,
      serverTime: "",
      ttt: "",
      dataSer: "",
      errorMsgCallData: "",
      // epoc
      formattedEpoch: '',
      intervalId: null,
      // polling
      pollingInterval: null,
      showQr: true,
      // text sugeess
      textsugess: '',
      showPad: false,
      loadingEnrollmentCheck: false,
      enrollmentStatus: ''
    };
  },
  computed: {
    isEnrollmentEvent() {
      return this.$route.query.event === 'enrollment';
    },
    getUrlPath() {
      return this.$route.query.token_event === undefined ||
        this.$route.query.token_event === ""
        ? "Not spectify {{token_event}}"
        : this.$route.query.token_event;
    },
    urlQr() {
      let currentUrl = `https://newmy.muic.io/smartauthenqr?token_event=${this.$route.query.token_event}&token_key=${this.formattedEpoch}`;
      return currentUrl;
    },
  },
  created() {
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
  },
  mounted() {
    if (this.$route.query.token_event !== undefined || this.$route.query.token_event !== "") {
      this.startPollingEpoch();
      this.getServerDateTime();
      this.getEventByToken()

      // polling
      this.pollingInterval = setInterval(() => {
        this.fetchAttendeeData();
      }, 15000);

    }
  },
  beforeDestroy() {
    this.stopPollingEpoch();
    clearInterval(this.pollingInterval);
  },
  methods: {
    onChange(checked) {
      this.showQr = checked
      console.log(`a-switch to ${checked}`);
    },
    onChangeEdit(checked) {
      this.showPad = checked
      console.log(`a-switch to ${checked}`);
    },
    // epoc ca;l
    startPollingEpoch() {
      this.updateEpoch(); // เรียกทันที
      this.intervalId = setInterval(this.updateEpoch, 10000); // ทุก 5 วิ
    },
    updateEpoch() {
      const epoch = Math.floor(Date.now() / 1000).toString(); // Unix Epoch
      const firstFive = epoch.slice(0, 5);
      const lastFive = epoch.slice(-5);

      const prefix = this.generateRandomString(4); // xxxx
      const infix = this.generateRandomString(4); // xxxx
      const suffix = this.generateRandomString(3); // xxx

      this.formattedEpoch = `${prefix}${firstFive}${infix}${lastFive}${suffix}`;
    },
    generateRandomString(length) {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    },
    stopPollingEpoch() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    // time ui data
    // polling api
    async fetchAttendeeData() {
      try {
        const res = await this.$http.get(
          `/smart-authen/event/${this.getUrlPath}/now/`,
        );
        if (res.status === 200) {
          this.dataAttanUser.push(res.data.attendees)
          this.dataAttanUser = res.data.attendees.sort((a, b) => {
            return new Date(b.checked_in_at) - new Date(a.checked_in_at);
          });
          this.countData = res.data.attendees.length
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.handleErrorCase(
          error.response.status,
          `/smart-authen/event/${this.getUrlPath}/now/`
        );
      }
    },
    // polling api
    checkDataRender(val, obj) {
      return Object.keys(val).length === 0 ? "-" : val[obj];
    },
    handleErrorCase(dataA, dataB) {
      this.$notification.open({
        style: {
          backgroundColor: "#ff1919",
          color: "#ffffff",
        },
        message: function (h) {
          return h("div", [h("strong", { class: "" }, `Error ${dataA}`)]);
        },
        description: `Problem issue connect api : ${dataB}`,
      });
    },
    updateCurrentTime() {
      this.currentTime = this.moment(
        this.ttt !== "" ? this.ttt : this.currentTime,
        "HH:mm:ss"
      )
        .add(1, "seconds")
        .locale("th")
        .format("LTS");
      this.ttt = this.currentTime;
    },
    // keyboard code.
    otherMethod(response) {
      if (response.event.keyCode >= 48 && response.event.keyCode <= 57) {
        let temp = response.event.keyCode - 48;
        this.valKey += `${temp}`;
      } else if (
        response.event.keyCode >= 96 &&
        response.event.keyCode <= 105
      ) {
        let temp = response.event.keyCode - 96;
        this.valKey += `${temp}`;
      } else if (
        response.event.keyCode === 8 ||
        response.event.keyCode === 46
      ) {
        this.valKey = this.valKey.substring(0, this.valKey.length - 1);
      } else if (response.event.keyCode == 188) {
        this.valKey = this.valKey + ",";
      }
    },
    clearDataObj() {
      this.dataBlacklist = [];
      this.dataProfile = {};
      this.valKey = "";
      this.hasSuccess = false
      this.loadingCheck = false
      this.enrollmentStatus = ''
    },
    // connect api
    async getServerDateTime() {
      this.serverTime = "";
      this.serverNowDate = "";
      try {
        const restime = await this.$http.get(
          `/hri/time_attendance/time_server/`
        );
        if (restime.status === 200) {
          this.dataSer = this.moment(restime.data.full_time).format(
            "DD / MMMM / YYYY"
          );
          this.serverTime = this.moment(restime.data.full_time)
            .locale("th")
            .format("LTS");
          this.serverNowDate = this.moment(restime.data.full_time)
            .locale("th")
            .format("YYYY-MM-DD");
          this.currentTime = this.serverTime;
        } else {
          const error = new Error('Request Failed');
          error.restime = restime;
          error.response = restime;
          throw error;
        }
      } catch (error) {
        this.serverTime = "";
        this.handleErrorCase(
          error.response.status,
          `Caught api '/hri/time_attendance/time_server/' process. Pleses refresh the page and try again.`
        );
      }
    },
    checkType(userId) {
      return userId.startsWith('130') ? 'staff' :
        userId.startsWith('6') || userId.startsWith('9') ? 'student' :
          'unknown';
    },
    async getEventByToken() {
      this.textsugess = ''
      this.dataAttanUser = []
      this.countData = 0
      this.loadingMainUi = true
      try {
        const res = await this.$http.get(
          `/smart-authen/event/${this.getUrlPath}/now/`,
        );
        if (res.status === 200) {
          this.loadingMainUi = false
          this.dataEvent = { ...res.data };
          this.dataAttanUser = res.data.attendees.sort((a, b) => {
            return new Date(b.checked_in_at) - new Date(a.checked_in_at);
          });
          this.countData = res.data.attendees.length
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.dataEvent = {}
        this.countData = 0
        this.loadingMainUi = false
        this.handleErrorCase(
          error.response.status,
          `/smart-authen/event/${this.getUrlPath}/now/`
        );
      }
    },
    async checkEnrollmentStatus(userId) {
      this.loadingEnrollmentCheck = true;
      this.enrollmentStatus = 'loading';
      try {
        const res = await this.$http.post(`/smart-authen/check-in/enrollment-check/`, {
          student_id: userId
        });
        if (res.status === 200 || res.status === 201) {
          this.enrollmentStatus = 'success';
        } else {
          this.enrollmentStatus = 'warning';
          this.textsugess = 'ยังไม่ได้ทำ form enrollment';
        }
      } catch (error) {
        this.enrollmentStatus = 'warning';
        this.textsugess = 'ยังไม่ได้ทำ form enrollment';
      } finally {
        this.loadingEnrollmentCheck = false;
      }
    },
    diffExpirseDate(testDate) {
      let formatTestDate = this.moment(testDate).format("YYYY-MM-DD");
      let weekLimit = this.moment(formatTestDate)
        .add(7, "days")
        .format("YYYY-MM-DD");
      let todayNow = this.moment().format("YYYY-MM-DD");
      if (this.moment(weekLimit).isBefore(todayNow)) {
        return false;
      } else {
        return true;
      }
    },
    async checkPoint(response) {
      this.textsugess = ''
      this.loadingCheck = true
      let newJson = {}
      let sendId = ''
      try {

        sendId = this.valKey;
        const sendData = new FormData();
        sendData.append("card_key", sendId);
        sendData.append("old_event", this.getUrlPath);
        if (this.showPad) {
          sendData.append("number", this.showPad ? 1 : 0);
        }
        const res = await this.$http.post(
          "/smart-authen/check-in/by-card/",
          sendData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if ([200, 201, '200', '201'].includes(res.status)) {

          // -------
          this.valKey = "";
          sendId = "";
          // -------

          // อัพเดท list
          let checkUserId = '';
          if (this.checkType(`${res.data.joiner}`) === 'student') {
            checkUserId = `${res.data.joiner_detail.student_id}`;
            newJson = {
              "user_id": `${res.data.joiner_detail.student_id}`,
              "full_name": `${res.data.joiner_detail.english_first_name} ${res.data.joiner_detail.english_last_name}`,
              "checked_in_at": res.data.created_at,
              'Photo': `${res.data.joiner_detail.img_url}`
            }
            this.dataAttanUser.push({
              "user_id": `${res.data.joiner_detail.student_id}`,
              "full_name": `${res.data.joiner_detail.english_first_name} ${res.data.joiner_detail.english_last_name}`,
              "checked_in_at": res.data.created_at,
              'check_in_type': res.data.check_in_type
            })
          } else {
            checkUserId = `${res.data.joiner_detail.code}`;
            newJson = {
              "user_id": `${res.data.joiner_detail.code}`,
              "full_name": `${res.data.joiner_detail.name} ${res.data.joiner_detail.surname}`,
              "checked_in_at": res.data.created_at,
              'Photo': `${res.data.joiner_detail.img}`
            }
            this.dataAttanUser.push({
              "user_id": `${res.data.joiner_detail.code}`,
              "full_name": `${res.data.joiner_detail.name} ${res.data.joiner_detail.surname}`,
              "checked_in_at": res.data.created_at,
              'check_in_type': res.data.check_in_type
            })
          }
          this.dataProfile = { ...newJson };
          this.dataAttanUser.sort((a, b) => {
            return new Date(b.checked_in_at) - new Date(a.checked_in_at);
          });
          // อัพเดท list
          this.countData++
          this.hasSuccess = true
          this.loadingCheck = false

          if (this.isEnrollmentEvent) {
            await this.checkEnrollmentStatus(checkUserId);
            setTimeout(() => {
              this.clearDataObj();
              this.textsugess = '';
            }, 3000);
          } else {
            setTimeout(() => this.clearDataObj(), 1500);
          }

        }
        else {

          if ([209, '209'].includes(res.status)) {
            console.log('209 Dupplications')
            this.textsugess = 'ผู้ใช้งานนี้ได้ทำการ check-in ไปแล้ว (check-in ซ้ำ)'
          }
          else if ([208, '208'].includes(res.status)) {
            console.log('208 No data')
            this.textsugess = 'ผู้ใช้งานนี้ไม่พบข้อมูล'
          }
          setTimeout(() => this.textsugess = '', 500);
          console.log('xxxx', error.res.status)

          const err = new Error('API Error');
          err.res = res;
          throw err;

        }

      } catch (error) {
        this.valKey = "";
        sendId = "";
        this.clearDataObj()
        this.loadingCheck = false
        this.handleErrorCase(
          error.response.status,
          `/smart-authen/check-in/by-card/`
        );
      }
    }
  },
};
</script>

<style scoped>
.card-loading {
  text-align: center;
  background: #FAF6E9;
  border-radius: 4px;

  padding: 30px 50px;
  margin: 20px 0;
}

.fullscreen-background {
  min-height: 95vh;
  width: 100%;
  background: url('../../../public/images/meetingRoom.png') no-repeat center center;
  background-size: cover;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
}

.desc p {
  margin-bottom: 1em;
}

.enrollment-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 30px 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.enrollment-result ::v-deep .ant-result-title {
  white-space: nowrap;
}

/* NEW PREMIUM UI STYLES */
.time-display-wrapper {
  padding: 10px 0;
}

.date-badge {
  display: inline-block;
  background: rgba(80, 141, 105, 0.1);
  color: #508D69;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border: 1px solid rgba(80, 141, 105, 0.2);
}

.digital-clock {
  font-size: 56px;
  font-weight: 700;
  letter-spacing: 2px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
}

.clock-icon {
  color: #508D69;
  font-size: 42px;
  filter: drop-shadow(0 4px 6px rgba(80, 141, 105, 0.3));
}

.stat-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.9);
  padding: 12px 24px;
  border-radius: 16px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.02);
  text-align: right;
  backdrop-filter: blur(8px);
}

.stat-label {
  color: #8c8c8c;
  font-size: 14px;
  margin: 0 0 4px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.stat-value {
  color: #471396;
  font-size: 32px;
  font-weight: 700;
  margin: 0;
}

.stat-unit {
  font-size: 16px;
  color: #8c8c8c;
  font-weight: 500;
}

.main-card-glass {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.6);
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.shadow-xl {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.event-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 8px;
}

.event-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

.event-subtitle span {
  font-weight: bold;
  color: #471396;
}

.event-badge {
  border-left: 8px solid #471396;
  background: linear-gradient(135deg, #7633fd 0%, #5b1cdb 100%);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 24px;
  box-shadow: 0 10px 20px rgba(118, 51, 253, 0.25);
}

.event-badge h4 {
  color: #ffffff;
  margin: 0;
  font-size: 18px;
  letter-spacing: 0.5px;
}

.alert-box {
  background-color: #fff1f0;
  border: 1px solid #ffa39e;
  border-radius: 16px;
  padding: 16px;
  text-align: center;
}

.result-box {
  border-radius: 16px;
  padding: 24px;
  transition: all 0.3s ease;
}

.success-bg {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
}

.default-bg {
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
}

.value-font {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin: 0;
}

.labelx-font {
  font-size: 16px;
  margin: 0;
}

.qr-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.qr-canvas {
  margin: 0 auto;
}

.photo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

/* .img-size-lock {
  width: 90%;
  height: 300px;
  border-radius: 10px;
} */

.img-size-lock {
  width: 100%;
  max-width: 200px;
  height: auto;
  aspect-ratio: 3/4;
  border-radius: 16px;
  object-fit: cover;
  border: 4px solid #ffffff;
  margin: 0 auto;
}

.logo-size {
  width: 300px;
  height: 100%;
  margin-top: 10px;
  z-index: -999;
}

.example {
  text-align: center;
  background: #60d5ff4d;
  border-radius: 4px;

  padding: 30px 50px;
  margin: 20px 0;
}


.profile-img {
  width: 100%;
  max-width: 180px;
  border-radius: 10px;
  object-fit: cover;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
}

.text-center {
  text-align: center;
}

.font-web {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.bg-success-check {
  background-color: #d9f7be;
}

.bg-success-default {
  background-color: #f0f0f0;
}
</style>

<style>
.ant-table-thead>tr>th {
  background-color: #fafafa !important;
  color: #000000 !important;
  text-align: center;
}

.ant-table-thead>tr>th {
  font-size: 14px;
}

.ant-table-tbody {
  font-size: 12px;
  background-color: #ffffff !important;
}

.ant-table-small>.ant-table-content .ant-table-header {
  background-color: #ffffff !important;
  border-radius: 4px 4px 0 0;
}

th.column-font,
td.column-font {
  padding: 10px;
  font-family: 'Sarabun', sans-serif !important;
  font-size: 14px;
  font-weight: 300;
  color: #000 !important;
}

.labelx-font {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: 900;
}

.bg-success-check {
  background-color: #ADEED9 !important;
}

.bg-success-default {
  background-color: #FAF6E9 !important;
}
</style>